import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import parse from 'html-react-parser';
import { format } from 'date-fns';
import { dateTimeFormat } from 'constants/formats';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import RecipientsTable from './RecipientsTable';

const CertificationViewBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCommunicationDetailsPage();
  const { communication } = data;

  const parsedDocument = communication?.body ? parse(communication.body) : '';
  const recipientsTotal = data.communication?.recipientsCount?.total ?? 0;
  const showPagination = recipientsTotal > 10;

  return (
    <div className="cv-body-wrapper">
      <div className="cv-card">
        <div className="cv-card-header">
          <span className="cv-card-label">{t('Email')}</span>
          <h2 className="cv-card-title mb-0">{communication?.subject}</h2>
        </div>

        <div className="cv-card-body">
          <div className="cv-field">
            <em className="icon ni ni-user-alt cv-field-icon" />
            <div>
              <span className="cv-field-label">{t('Sender')}</span>
              <span className="cv-field-value">
                {communication?.sender?.email}
              </span>
            </div>
          </div>

          <div className="cv-field">
            <em className="icon ni ni-calendar cv-field-icon" />
            <div>
              <span className="cv-field-label">{t('SentDate')}</span>
              <span className="cv-field-value">
                {communication?.date
                  ? format(new Date(communication.date), dateTimeFormat)
                  : ''}
              </span>
            </div>
          </div>

          <div className="cv-field">
            <em className="icon ni ni-mail cv-field-icon" />
            <div>
              <span className="cv-field-label">{t('Subject')}</span>
              <span className="cv-field-value">{communication?.subject}</span>
            </div>
          </div>

          <div className="cv-field cv-field--last">
            <em className="icon ni ni-file cv-field-icon" />
            <div>
              <span className="cv-field-label">{t('AttachedFiles')}</span>
              {data?.attachedDocuments && data.attachedDocuments.length > 0 ? (
                <div className="cv-attachments">
                  {data.attachedDocuments.map((attachment: any) => (
                    <span key={attachment?._id} className="cv-attachment">
                      <em className="icon ni ni-file-doc" />
                      {attachment?.name}
                    </span>
                  ))}
                </div>
              ) : (
                <span className="cv-field-value cv-field-value--muted">
                  {t('NoAttachments')}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {parsedDocument && (
        <div className="cv-card">
          <div className="cv-card-header">
            <span className="cv-card-label">{t('Textual')}</span>
          </div>
          <div className="cv-card-body">
            <div
              className="cv-body-content"
              style={{
                whiteSpace:
                  typeof parsedDocument === 'string' ? 'pre-line' : 'normal',
              }}
            >
              {parsedDocument}
            </div>
          </div>
        </div>
      )}

      <div className="cv-card">
        <div className="cv-card-header">
          <span className="cv-card-label">{t('Recipients')}</span>
          {recipientsTotal > 0 && (
            <span className="cv-count-badge">{recipientsTotal}</span>
          )}
        </div>
        <RecipientsTable />
        {showPagination && (
          <div className="cv-pagination">
            <TablePagination
              defaultPage={data.recipientsPage}
              totalRows={recipientsTotal}
              onChangePage={actions.handleChangeRecipientsPage}
              onChangeRowsPerPage={actions.handleChangeRecipientsRowsPerPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificationViewBody;
